// extracted by mini-css-extract-plugin
export default {"imgLoading":"AIImgLoading__imgLoading___FLabi","fireworks":"AIImgLoading__fireworks___gBHAG"};